import { render, staticRenderFns } from "./WealthPerformance.vue?vue&type=template&id=e1d01214&scoped=true"
import script from "./WealthPerformance.vue?vue&type=script&lang=ts&setup=true"
export * from "./WealthPerformance.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WealthPerformance.vue?vue&type=style&index=0&id=e1d01214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d01214",
  null
  
)

export default component.exports